import type { RejectedError } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { NetworkLogoAction } from '../../../domains/networkLogo/actions.types';

import type { CurrentNetworkLogo, NetworkLogo } from './types';

export type { NetworkLogoAction };

const initialState: CurrentNetworkLogo = {};

const setPending = () => ({ pending: true });
const setRejected = (error: RejectedError) => ({ rejected: error });
const setFulfilled = (networkLogo: NetworkLogo | null) => ({ fulfilled: networkLogo });

const reducer: Reducer<CurrentNetworkLogo, NetworkLogoAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_LOGO.LOAD_PENDING':
      return setPending();
    case 'NETWORK_LOGO.LOAD_FULFILLED':
      return setFulfilled(action.payload.currentNetworkLogo);
    case 'NETWORK_LOGO.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
